import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
// Components
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material';
import { ExpandMore, Edit, Delete } from '@mui/icons-material';
import { ICounty } from '../../../models';
// Types

interface IMobileCounties {
  original: ICounty;
  handleEdit?: (val: ICounty) => void;
  handleDelete?: (val: ICounty) => void;
}

export const MobileCounties: FC<IMobileCounties> = ({ original, handleEdit, handleDelete }) => {
  const classes = useStyles();
  const { name, state, taxRate } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{name}</Typography>
          <div className={classes.buttonsWrapper}>
            {handleEdit && (
              <IconButton
                className={classes.editButton}
                color="primary"
                onClick={e => {
                  e.stopPropagation();
                  handleEdit(original);
                }}
                size="large"
              >
                <Edit />
              </IconButton>
            )}
            {handleDelete && (
              <IconButton
                className={classes.deleteButton}
                color="default"
                onClick={e => {
                  e.stopPropagation();
                  handleDelete(original);
                }}
                size="large"
              >
                <Delete />
              </IconButton>
            )}
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            County:
          </FormLabel>
          <Typography component="span" variant="body2">
            {name || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            State:
          </FormLabel>
          <Typography component="span" variant="body2">
            {state || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Tax Rate:
          </FormLabel>
          <Typography component="span" variant="body2">
            {taxRate || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
